<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false">Close</v-btn>
    </v-snackbar>
    <StaffNav v-if="$route.query.showNav !== 'false'" />
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-2" outlined tile height="100%">
          <v-card>
            <v-card-title style="background-color: #2b3990">
              <span class="headline white--text">{{ titleForm }}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="isFormValid" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <v-menu
                        ref="calendarMenu"
                        v-model="calendarMenu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="newStartDate"
                            label="Start Date *"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'Start date is required']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newStartDate"
                          no-title
                          scrollable
                          @input="calendarMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-menu
                        ref="calendar2Menu"
                        v-model="calendar2Menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="newEndDate"
                            label="End Date *"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'End date is required']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newEndDate"
                          no-title
                          scrollable
                          @input="calendar2Menu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-textarea
                        v-model="newReason"
                        label="Reason for time off *"
                        outlined
                        :rules="[(v) => !!v || 'Reason is required']"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-row dense align="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-switch
                            v-model="usePTOHours"
                            label="Are you wanting to use PTO hours?"
                          ></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="usePTOHours">
                          <v-text-field
                            v-model.number="ptoHours"
                            type="number"
                            min="0"
                            label="PTO Hours"
                            :rules="usePTOHours ? [(v) => v >= 0 || 'Must be 0 or more'] : []"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        label="Manager *"
                        v-model="newManager"
                        :items="managers"
                        item-text="Name"
                        item-value="Name"
                        :rules="[(v) => !!v || 'Manager is required']"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        label="Program *"
                        v-model="newProgram"
                        :items="programs"
                        item-text="Name"
                        item-value="_id"
                        :rules="[(v) => !!v || 'Program is required']"
                      ></v-select>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        label="Date and Time Requested"
                        v-model="newRequestDate"
                        readonly
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      v-if="isAdmin && newApproved === ''"
                    >
                      <v-btn @click="approveRequest" class="success"
                        >Approve</v-btn
                      >
                      <v-btn @click="denyRequest" class="error ml-5"
                        >Deny</v-btn
                      >
                    </v-col>

                    <v-col v-if="newApproved === 'Denied'">
                      <v-text-field
                        v-model="newApproved"
                        label="Status"
                        class="Red pa-8"
                        readonly
                      ></v-text-field>
                      <v-textarea
                        v-model="newDeniedReason"
                        label="Reason Request Wasn't Approved *"
                        outlined
                        class="ma-4"
                        :rules="
                          newApproved === 'Denied'
                            ? [(v) => !!v || 'Denial reason is required']
                            : []
                        "
                      ></v-textarea>
                      <v-text-field
                        :label="signedByTitle"
                        v-model="newSignedBy"
                        readonly
                      ></v-text-field>
                    </v-col>

                    <v-col v-if="newApproved === 'Approved'">
                      <v-text-field
                        v-model="newApproved"
                        label="Status"
                        class="Green pa-8"
                        readonly
                      ></v-text-field>
                      <v-text-field
                        :label="signedByTitle"
                        v-model="newSignedBy"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              
              <v-btn
                  fab
                  small
                  @click="showPrintModal()"
                  class="mr-8 mb-2 white--text"
                  color="#2b6993"
                  elevation="4"
                  >
                  <v-icon>print</v-icon>
              </v-btn>
              <v-btn
                color="primary"
                :loading="loading"
                :disabled="!isFormValid || loading"
                @click="updateTimeOff"
              >
                Update
              </v-btn>
              <v-btn color="grey" text @click="close" :disabled="loading">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import Foot from "../../components/Footer.vue";
import DateTimeUtil from "../../../utils/date-time.util";
import StaffNav from "../../components/StaffNav.vue";
import Swal from "sweetalert2";
import TimeOffService from "@/service/timeOff.service";
import PrintUtil from "../../../utils/print-util";

const url = require("../../client_config/config").url;

export default {
  components: {
    StaffNav,
    Foot,
  },
  props: ["timeOffRequestID"],

  data() {
    return {
      isFormValid: false,
      loading: false,
      headers: [
        {
          text: "Staff",
          align: "start",
          value: "StaffID.Name",
        },
        { text: "Start Date", value: "StartDate" },
        { text: "End Date", value: "EndDate" },
        { text: "Date Requested", value: "CreatedDate" },
        { text: "Reason", value: "Reason" },
        { text: "Status", value: "Approved" },
        { text: "Signed By", value: "SignedBy" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      calendarMenu: false,
      calendar2Menu: false,
      role: localStorage.getItem("userRole"),
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      msg: false,
      menu: false,
      signed: false,
      text: "",
      timeOff: {},
      programs: [],
      managers: [],
      staffID: this.$route.params.employeeID,
      staff: "",
      timeOffID: "",
      newStartDate: "",
      newEndDate: "",
      newReason: "",
      newProgram: "",
      newManager: "",
      newApproved: "",
      newDeniedReason: "",
      newSignedBy: "",
      signedByTitle: "",
      approved: false,
      denied: false,
      newRequestDate: "",
      isAdmin: false,
      isLoading: true,
      newSignedDate: "",
      newSignedUser: "",
      titleForm: "",
      token: localStorage.getItem('token'),
      usePTOHours: false,
      ptoHours: 0,
      originalApproved: null,
    };
  },
  computed: {
      generateDownloadUrl() {
        return `${url}/timeoff/print/${this.timeOffID}`;
      },
  },
  created() {
    this.getTimeOffRequest();
    this.getPrograms();
    this.getManagers();
    this.checkAdminRole();


    let timeOffId = this.$route.query.view;

    if (timeOffId) {
      TimeOffService.getById(timeOffId).then((response) => {
        this.viewTimeOff(response.data.timeOff);
      })
    }

  },

  async mounted() {
      window.addEventListener('keydown', async (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.timeOffID, this.token, 'TimeOffRequest');
      });
  },

  beforeDestroy() {
      window.removeEventListener('keydown', (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.timeOffID, this.token, 'TimeOffRequest');
      });
  },
  methods: {
    checkAdminRole() {
      const adminRoles = [
        "Administration",
        "Program Coordinator",
        "Human Resources",
        "Program Manager",
        "Client Services Manager",
      ];
      this.isAdmin = adminRoles.includes(localStorage.getItem("userRole"));
    },

    async getManagers() {
      try {
        const companyIds = JSON.parse(localStorage.getItem("userCompanies"));
        const response = await axios.get(`${url}/users`, {
          params: { Company: companyIds },
        });
        this.managers = response.data.users;
      } catch (error) {
        this.showError("Failed to load managers");
      }
    },

    async getPrograms() {
      try {
        const companyIds = JSON.parse(localStorage.getItem("userCompanies"));
        const response = await axios.get(`${url}/units`, {
          params: { Company: companyIds },
        });
        this.programs = response.data.units;
      } catch (error) {
        this.showError("Failed to load programs");
      }
    },

    async getTimeOffRequest() {
      this.isLoading = true;
      try {
        const response = await axios.get(
          `${url}/timeOff/${this.timeOffRequestID}`
        );
        this.timeOff = response.data.timeOff;
        this.viewTimeOff(this.timeOff);
      } catch (error) {
        this.showError("Failed to load time off request");
      } finally {
        this.isLoading = false;
      }
    },

    viewTimeOff(item) {
      this.staff = item.StaffID.Name;
      this.staffID = item.StaffID;
      this.titleForm = "Viewing Time Off Request";
      this.newStartDate = item.StartDate;
      this.newEndDate = item.EndDate;
      this.newReason = item.Reason;
      this.usePTOHours = !!item.UsePTOHours;
      this.ptoHours = Number(item.PTOHours || 0);
      this.newManager = item.Manager;
      this.newProgram = item.Program;
      this.newApproved = item.Approved;
      this.originalApproved = item.Approved;
      this.newDeniedReason = item.DeniedReason;
      this.newRequestDate = DateTimeUtil.toLocalDateTime(item.CreatedDate);
      this.newSignedUser = item.SignedUser;
      this.newSignedDate = DateTimeUtil.toLocalDateTime(item.SignedDate);
      this.timeOffID = item._id;

      this.newSignedBy = this.newSignedUser
        ? `${this.newSignedUser} ${this.newSignedDate}`
        : item.SignedBy;

      this.signedByTitle =
        this.newApproved === "Denied" ? "Denied By" : "Approved By";
    },

    async updateTimeOff() {
      if (!this.$refs.form.validate()) {
        this.showError("Please fill out all required fields");
        return;
      }

      this.loading = true;
      const approvedChanged = this.newApproved !== this.originalApproved;
      const requestBody = {
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        UsePTOHours: this.usePTOHours,
        PTOHours: this.usePTOHours ? Number(this.ptoHours) : 0,
        Reason: this.newReason,
        Program: this.newProgram,
        Manager: this.newManager,
        // Only send Approved when status actually changed
        Approved: approvedChanged ? this.newApproved : undefined,
        SignedBy: this.newSignedBy,
        StaffID: this.staffID,
        CreatedDate: new Date(),
        DeniedReason: this.newDeniedReason,
        SignedDate: this.newSignedDate,
        SignedUser: this.newSignedUser,
      };

      try {
        await axios.put(
          `${url}/timeOff/${this.timeOffID}`,
          requestBody
        );
        const message = approvedChanged
          ? (this.newApproved === "Approved"
              ? "The time off request has been approved successfully."
              : this.newApproved === "Denied"
                ? "The time off request has been denied."
                : "The time off request status has been updated.")
          : "The time off request has been updated successfully.";

        await Swal.fire({
          icon: "success",
          text: message,
        });
        this.close();
      } catch (error) {
        this.showError("Failed to update time off request");
      } finally {
        this.loading = false;
      }
    },

    showError(message) {
      Swal.fire({
        icon: "error",
        text: message,
      });
    },

    approveRequest() {
      const now = new Date();
      const isoDateTime = now.toISOString();
      const userName = localStorage.getItem("Name");

      this.newSignedBy = `${userName} ${isoDateTime}`;
      this.newSignedDate = isoDateTime;
      this.newSignedUser = userName;
      this.newApproved = "Approved";
      this.approved = true;
      this.denied = false;
      this.signedByTitle = "Approved By";
    },

    denyRequest() {
      const now = new Date();
      const isoDateTime = now.toISOString();
      const userName = localStorage.getItem("Name");

      this.newApproved = "Denied";
      this.denied = true;
      this.approved = false;
      this.newSignedBy = `${userName} ${isoDateTime}`;
      this.newSignedDate = isoDateTime;
      this.newSignedUser = userName;
      this.signedByTitle = "Denied By";
    },

    clearData() {
      this.newStartDate = "";
      this.newEndDate = "";
      this.newReason = "";
      this.newManager = "";
      this.newProgram = "";
      this.newApproved = "";
      this.newDeniedReason = "";
      this.newRequestDate = "";
      this.newSignedBy = "";
      this.approved = false;
      this.denied = false;
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },

    close() {
      this.clearData();
      this.$router.go(-1);
    },
    async showPrintModal() {
        PrintUtil.showPrintOption(this.generateDownloadUrl, this.timeOffID, this.token,'TimeOffRequest');
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
